import React from "react";
import { Autocomplete, TextField } from "@mui/material";

export default function CarrierEditInput(props) {
  const { id, field, value, api, carrierList = [] } = props;

  const [inputValue, setInputValue] = React.useState(value || "");
  const [open, setOpen] = React.useState(false);

  return (
    <Autocomplete
      freeSolo
      options={carrierList}
      value={inputValue}
      inputValue={inputValue}
      open={open && carrierList.length > 0}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);

        api.setEditCellValue({
          id,
          field,
          value: newInputValue,
        });
      }}
      onChange={(event, newValue) => {
        const finalValue = newValue || "";

        setInputValue(finalValue);

        api.setEditCellValue({
          id,
          field,
          value: finalValue,
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus
          variant="standard"
          placeholder="Select carrier"
          fullWidth
        />
      )}
      sx={{
        width: "100%",
        "& .MuiAutocomplete-inputRoot": {
          padding: "0 !important",
        },
      }}
    />
  );
}
